import ahoy from 'ahoy.js'
import config from 'config'

const SIGNUP_CONVERSION_PENDING_KEY = 'fb_signup_conversion_pending'

export default {
  trackPageView(path) {
    window.dataLayer = window.dataLayer || []
    const eventData = {
      'event': 'virtualPageView',
      'page': path,
      'location': window.location.origin + path
    }

    // Send page view
    window.dataLayer.push(eventData)
  },

  trackEvent(eventCategory, eventAction = undefined, eventLabel = undefined, eventValue = undefined) {
    window.dataLayer = window.dataLayer || []
    const eventData = {
      'event': 'eventTracking',
      'category': eventCategory,
      'action': eventAction,
      'label': eventLabel,
      'value': eventValue
    }

    // Send custom event
    window.dataLayer.push(eventData)
  },

  // Sign-up conversion (secondary action in Google Ads).
  // Pass the user's email so GTM's User-Provided Data variable can hash
  // it and forward to Google Ads Enhanced Conversions.
  trackSignupConversion(email) {
    window.dataLayer = window.dataLayer || []
    const eventData = {
      'event': 'sign_up_conversion'
    }

    if (email) {
      eventData.user_data = { email_address: email }
    }

    window.dataLayer.push(eventData)
  },

  // Strava/Garmin OAuth rarely returns an email, and a sign-up conversion pushed
  // without one cannot be matched to the ad click (Enhanced Conversions match on
  // the hashed email). So when the email is missing at signup, the push is
  // deferred to the onboarding account step, where the user types it. The flag
  // lives in sessionStorage because signup ends in a full page redirect.
  deferSignupConversion() {
    try {
      sessionStorage.setItem(SIGNUP_CONVERSION_PENDING_KEY, '1')
    } catch (e) {
      // noop
    }
  },

  flushSignupConversion(email) {
    try {
      if (sessionStorage.getItem(SIGNUP_CONVERSION_PENDING_KEY) !== '1') return
      sessionStorage.removeItem(SIGNUP_CONVERSION_PENDING_KEY)
    } catch (e) {
      return
    }

    this.trackSignupConversion(email)
  },

  // Subscription conversion (primary action in Google Ads — bid toward this).
  trackSubscriptionConversion(email, value = undefined, currency = 'USD') {
    window.dataLayer = window.dataLayer || []
    const eventData = {
      'event': 'subscription_conversion'
    }

    if (email) {
      eventData.user_data = { email_address: email }
    }

    if (value !== undefined && value !== null) {
      eventData.value = value
      eventData.currency = currency
    }

    window.dataLayer.push(eventData)
  },

  ahoyTrackEvent(event, data = {}) {
    ahoy.track(event, data)
  },

  ahoyTrackPageView(title) {
    ahoy.trackView({ title })
  },

  // ---------------------------------- */
  // Google Optimize
  // ---------------------------------- */

  // Activate Google Optimize Experiment via GTM
  activateExperiment(name) {
    window.dataLayer.push({
      'event': `optimize.activate.${name}`
    })
  },

  getExperimentValue(id) {
    return new Promise((resolve) => {
      window.dataLayer.push('event', 'optimize.callback', {
        name: id,
        callback: (value) => resolve(value)
      })
    })
  },

  // ---------------------------------- */
  // End of Google Optimize
  // ---------------------------------- */

  resetDatalayer() {
    try {
      if (!config.google_tag_manager_id) {
        return
      }

      if (!window.google_tag_manager) {
        return
      }

      if (!window.google_tag_manager[config.google_tag_manager_id]) {
        return
      }

      window.google_tag_manager[config.google_tag_manager_id].dataLayer.reset()
    } catch (e) {
      throw new Error('Failed to reset dataLayer')
    }
  }
}
